import { render, staticRenderFns } from "./creditRecord.vue?vue&type=template&id=0a8cc56a&scoped=true&"
import script from "./creditRecord.vue?vue&type=script&lang=js&"
export * from "./creditRecord.vue?vue&type=script&lang=js&"
import style0 from "./creditRecord.vue?vue&type=style&index=0&id=0a8cc56a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8cc56a",
  null
  
)

export default component.exports